import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'row-checkbox',
  template: `
    <mat-checkbox
      class="cellcheckbox custom-mat-checkbox"
      [disabled]="disabled"
      [checked]="checked"
      (change)="checkChanged($event)"
    ></mat-checkbox>
  `,
  styles: [
    `
      ::ng-deep .mat-checkbox .mat-checkbox-frame {
        border: 1px solid #c5c5c5 !important;
      }
      ::ng-deep .mat-checkbox-disabled .mat-checkbox-background {
        background-color: #d3d3d3;
      }
    `,
  ],
})
export class RowCheckboxPartsComponent implements ICellRendererAngularComp {
  public params: any;
  checked: boolean = false;
  disabled: boolean = false;

  agInit(params: any): void {
    this.params = params;
    this.checked = params.data.rowCheckBox || false;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  checkChanged(event: any): void {
    const isGrid3 = this.params.context?.gridType === 'grid3'; // Identify which grid
    this.params.context?.componentParent?.userCheckChanged(
      event.checked,
      this.params.node.rowIndex,
      isGrid3
    );
  }
}
